export default __webpack_public_path__ + "static/mobile_dock_m-86f0a83fb555461d2a3ac27371f70ea0.png";